import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";

export interface CoordinatedAgentRow {
  agent_id: string;
  user_id: string | null;
  full_name: string | null;
  email: string | null;
  workspace_id: string | null;
  coordinator_user_id: string | null;
}

export function useCoordinatedAgents() {
  const { user, activeWorkspaceId } = useAuth();
  return useQuery({
    queryKey: ["coordinated-agents", user?.id ?? null, activeWorkspaceId ?? null],
    enabled: Boolean(user?.id && activeWorkspaceId),
    staleTime: 60_000,
    queryFn: async (): Promise<CoordinatedAgentRow[]> => {
      const { data: coordinates, error: gateError } = await supabase.rpc(
        "is_coordinator_in_org" as never,
        { p_org_id: activeWorkspaceId } as never,
      );
      if (gateError || !coordinates) return [];
      const { data, error } = await supabase.rpc("list_coordinated_agents" as never);
      if (error) return [];
      return (data as CoordinatedAgentRow[] | null) || [];
    },
  });
}
